import apiHelpers from '@/utils/api'
import { AxiosPromise } from 'axios'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AloDbUser } from '@/models/alodb/AloDbUser'
import { AloBaseArray } from '@/models/alo/AloBaseArray'
import { AloDbRoleMapping } from '@/models/alodb/AloDbRoleMapping'


//test
export default {  
  getUsers(): AxiosPromise<AlrContainer<AloBaseArray<AloDbUser>>> {
    
    return apiHelpers.apiCall({ 
      url: 'api/admin/user', 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloBaseArray<AloDbUser>>(JSON.parse(data),AloDbUser.createAloDbUserArray)
      }]
    })
  },
  getUser(id:number):AxiosPromise<AlrContainer<AloDbUser>> {
    return  apiHelpers.apiCall({ 
      url: `api/admin/user/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloDbUser>(JSON.parse(data),AloDbUser.createAloDbUserWithDetail)
      }]
    })
  },
  saveUser(user:AloDbUser):AxiosPromise<AlrContainer<AloDbUser>> {
    if(user.USR_ID && user.USR_ID > 0) {
      return  apiHelpers.apiCall({ 
        url: `api/admin/user/${user.USR_ID}`, 
        method: 'PUT',
        data: user,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbUser>(JSON.parse(data),AloDbUser.createAloDbUserWithDetail)
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `api/admin/user`, 
        method: 'POST',
        data: user,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbUser>(JSON.parse(data),AloDbUser.createAloDbUserWithDetail)
        }]
      })    
    }    
  },
  getUserRoleMap(id:number, explicit:boolean):AxiosPromise<AlrContainer<AloBaseArray<AloDbRoleMapping>>>{
    return apiHelpers.apiCall({ 
      //url: `api/admin/user/${id}/rolemap/`, 
      url: `api/admin/rolemap/?usrid=${id}&explicit=${explicit?1:0}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloBaseArray<AloDbRoleMapping>>(JSON.parse(data),AloDbRoleMapping.createAloDbRoleMappingArray)
      }]
    })
  },
  addUserRoleMapping({usrId,mapObject,mapId,rolKey}:{usrId:number,mapObject:string,mapId:number,rolKey:string}) {    
    return  apiHelpers.apiCall({ 
      url: `api/admin/rolemap`, 
      method: 'POST',
      data: {
        MAP_OBJECT:mapObject,
        MAP_ID:mapId,
        USR_ID:usrId,
        ROL_KEY:rolKey
      },
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloDbRoleMapping>(JSON.parse(data),AloDbRoleMapping.createAloDbRoleMapping)
      }]
    })  
  },
  removeUserRoleMapping({usrId,mapObject,mapId,rolKey}:{usrId:number,mapObject:string,mapId:number,rolKey:string}) {    
    return  apiHelpers.apiCall({ 
      url: `api/admin/rolemap`, 
      method: 'DELETE',
      data: {
        MAP_OBJECT:mapObject,
        MAP_ID:mapId,
        USR_ID:usrId,
        ROL_KEY:rolKey
      },
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloDbRoleMapping>(JSON.parse(data),AloDbRoleMapping.createAloDbRoleMapping)
      }]
    })  
  },
  changePassword({usrId,oldPassword,newPassword}:{usrId:number,oldPassword:string|null,newPassword:string}) {
    return  apiHelpers.apiCall({ 
      url: `api/password/user/${usrId}`, 
      method: 'PUT',
      data: {
        oldPassword,
        newPassword
      },
      transformResponse: [function (data:string) {          
        return new AlrContainer<any>(JSON.parse(data),(t) => t)
      }]
    })  
  },
  deleteUser(id:number):AxiosPromise<AlrContainer<AloDbUser>> {    
    return  apiHelpers.apiCall({ 
      url: `api/admin/user/${id}`, 
      method: 'DELETE',      
      transformResponse: [function (data:string) {          
        return new AlrContainer<any>(JSON.parse(data),i => i)
      }]
    })       
  }
  
}